import { render, staticRenderFns } from "./SignupShareOverlay.vue?vue&type=template&id=660c7c70&scoped=true&"
import script from "./SignupShareOverlay.vue?vue&type=script&lang=js&"
export * from "./SignupShareOverlay.vue?vue&type=script&lang=js&"
import style0 from "./SignupShareOverlay.vue?vue&type=style&index=0&id=660c7c70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660c7c70",
  null
  
)

export default component.exports